<script setup>
import { ref } from 'vue';

import { useAppState } from '../store/ocg-app-state';
import { session, supabase } from '../supabase';

const appState = useAppState();

const dialog = ref(false);
const isBusy = ref(false);
const fn = ref('');
const url = ref('');

const rules = {
  nameNonEmpty: (value) => {
    if (value.trim().length < 1) {
      return 'Name cannot be empty';
    }
    return true;
  },
};

function close() {
  // Reset fields
  fn.value = appState.currentUser?.fn ?? '';
  // Close the dialog
  dialog.value = false;
}

function open() {
  fn.value = appState.currentUser?.fn ?? '';
  url.value = appState.currentUser?.url ?? '';
  dialog.value = true;
}

async function save(event) {
  // wait for validation to complete
  const result = await event;
  if (!result.valid) return;

  isBusy.value = true;
  try {
    const { error } = await supabase
      .from('person')
      .update({
        card: {
          fn: fn.value.trim(),
          url: url.value.trim() || undefined,
        },
      })
      .eq('id', session.value?.user.id);

    if (error) throw error;
  }
  catch (error) {
    if (error instanceof Error) {
      // TODO: Use notification snack-bar
      // eslint-disable-next-line no-alert
      alert(error.message);
    }
    else {
      console.error(error);
    }
    return;
  }
  finally {
    isBusy.value = false;
  }
  appState.retrieveProfile();
  close();
}

defineExpose({ open });
</script>

<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form :disabled="isBusy" @submit.prevent="save">
      <v-card :loading="isBusy" :disabled="isBusy">
        <template #loader="{ isActive }">
          <v-progress-linear
            :active="isActive"
            color="primary"
            height="4"
            indeterminate
          />
        </template>
        <v-card-title class="text-headline-small">
          Edit Profile
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="fn"
            label="Name"
            placeholder="Your full name"
            autocomplete="name"
            :rules="[rules.nameNonEmpty]"
          />
          <v-text-field
            v-model="url"
            label="Web"
            placeholder="Your website or social media URL"
            autocomplete="url"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn type="submit" color="primary">
            Save
          </v-btn>
          <v-btn color="secondary" @click="close">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
  <!-- <button @click="open" color="white" variant="text">
    Edit Profile <i class="fa-solid fa-user-edit" style="color: #ffffff" />
  </button> -->
</template>

<style scoped>
i {
  margin-left: 10px;
  min-width: 2em;
}
</style>
